import { environment } from '@helpers/environment';

/**
 * A helper function that pushes an event to the data layer.
 * @param {string} event The event name.
 * @param {object} interaction The interaction data, eg. click_text, link_url, etc.
 */
export default function dataLayerPush({ event, interaction = {} }) {
  // Do nothing if no event has been passed.
  if (typeof event !== `string`) {
    return;
  }

  const dataLayerObject = {
    event,
    interaction: {
      path: window.location.pathname,
      ...interaction
    }
  };

  // Push to event on all environments except local.
  if ([`master`, `staging`, `develop`].indexOf(environment) !== -1) {
    window.dataLayer.push(dataLayerObject);
  }

  // Log the event for debugging.
  if (environment !== `master`) {
    /* eslint-disable no-console */
    console.log(`Data layer push:`, dataLayerObject);
  }
}
